module.exports = __webpack_public_path__ + "static/media/hero-vbn.e2769f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-vbn.jpg
// module id = 204
// module chunks = 51